import React from 'react';

/**
 * Footer — site-wide footer with XMPie branding and legal links.
 *
 * Displays the XMPie logo, Privacy Policy, Terms of Use, and
 * Contact Support links alongside a dynamic copyright year.
 */
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-links">
          <img src={`${process.env.PUBLIC_URL}/images/xmpie-footer-white.svg`} alt="XMPie" className="footer-logo" />
          <a href="https://www.xmpie.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          <a href="https://www.xmpie.com/terms-of-use/" target="_blank" rel="noopener noreferrer">Terms of Use</a>
          <a href="https://www.xmpie.com/support/contact-our-support-team/" target="_blank" rel="noopener noreferrer">Contact Support</a>
        </div>
        <div className="footer-brand">
          <span className="footer-copy">&copy; {currentYear} XMPie, A CareAR Company. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
